export const isLogged = () => {
    const token = localStorage.getItem("Authorization");
    let isLogged = false;
    if (token && token.length > 0) {
      isLogged = true;
    }
    return isLogged;
};

type tokenResponse = {
    data: {
        access_token: string,
        expires_in: string,
        refresh_token: string
    }
};

export const setTokens = (response: tokenResponse) => {
    localStorage.setItem("Authorization", 'Bearer ' + response.data.access_token);
    localStorage.setItem("access_token_exp", response.data.expires_in);
    localStorage.setItem("refresh_token", response.data.refresh_token);
};

export const getToken = () => {
    return localStorage.getItem("Authorization");
};

export const removeTokens = () => {
    localStorage.removeItem('Authorization');
    localStorage.removeItem('refresh_token');
    localStorage.removeItem('access_token_exp');
};